import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BlogIndex from './index';         // This is your blog index (currently InsideFlashFluency/index.js)
import BlogPostPage from './BlogPostPage';

export default function BlogRouter() {
  return (
    <Routes>
      {/* When the URL is exactly /inside-flash-fluency, render the blog index */}
      <Route path="/" element={<BlogIndex />} />
      {/* When the URL is /inside-flash-fluency/:slug, render the blog post */}
      <Route path=":slug" element={<BlogPostPage />} />
    </Routes>
  );
}